import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_VARIANT, ROLE_REMOVE_VARIANT } from 'helpers/roles';
import AdminTable from 'layouts/AdminTable';

import columnConfig from './columnConfig';

const List = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const newSize = () => history.push(`${window.location.pathname}/add`);

  return (
    <AdminTable title={t('list.variantsList')}>
      {isGranted(ROLE_CREATE_VARIANT) && (
        <FormControlButtons
          handleSubmit={newSize}
          submitText={`${t('form.addVariant')} +`}
        />
      )}
      <DataGrid
        actions={true}
        editPath={`${window.location.pathname}/edit`}
        remove={isGranted(ROLE_REMOVE_VARIANT)}
        export={true}
        paginationTop={true}
        paginationBottom={false}
        url="variants"
        reportName="variant"
        columns={columnConfig(t)}
        role="VARIANT"
      />
    </AdminTable>
  );
};

export default List;
